import React from 'react';
import logo from './images/logo.png';
import './App.css';
import Youtube from './Youtube';
import { Link } from 'react-router-dom'
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Politics from './Politics'
import Technology from './Technology'
import Sports from './Sports'
import News from './News'
import Bollywood from './Bollywood'

function App() {
  return (
    <Router>
        <div className="youtube">
          <div className='navbar'>
            <Link to='/'>
            <img src={logo} className='yt_logo' alt='' />
            </Link>
          </div>
          {/* <Auth /> */}
          <Routes>
            <Route exact path='/' element={<Youtube />} />
            <Route exact path='/bollywood' element={<Bollywood />} />
            <Route exact path='/news' element={<News />} />
            <Route exact path='/technology' element={<Technology />} />
            <Route exact path='/politics' element={<Politics />} />
            <Route exact path='/sports' element={<Sports />} />
          </Routes>          
        </div>
      
      </Router>
      
  );
}

export default App;
